import { Cancel01Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  Field,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@motley/design"
import { useState } from "react"

type Props = {
  onChange: (query: string) => void
}

export default function DefinitionSearch({ onChange }: Props) {
  const [searchQuery, setSearchQuery] = useState("")

  const handleChange = (value: string) => {
    setSearchQuery(value)
    onChange(value)
  }

  return (
    <Field className="py-1 group-data-[state=collapsed]:hidden">
      <InputGroup>
        <InputGroupInput
          id="definition-search"
          placeholder="Search…"
          value={searchQuery}
          onChange={(e) => {
            handleChange(e.target.value)
          }}
        />
        {!!searchQuery && (
          <InputGroupAddon align="inline-end">
            <HugeiconsIcon
              icon={Cancel01Icon}
              className="cursor-pointer"
              onClick={() => {
                handleChange("")
              }}
            />
          </InputGroupAddon>
        )}
      </InputGroup>
    </Field>
  )
}
